import React from 'react'
import './index.scss'
import earnImg from '@/assets/images/earn.png'
const NoEarn = () => {
  return (
    <div className="noearn__box">
      <img src={earnImg} alt=""/>
      <span>暂无资金记录哦</span>
    </div>
  )
}
export default NoEarn
